import React from 'react';
import styled from '@emotion/styled';
import { Button } from 'react-bootstrap';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

import colours from '~/utils/colours';
import AddPopover from '../Components/Popovers/Add';
import { openGoto } from '~/App/Components/Modals/Goto';
import { HeaderFilter } from '../Components/HeaderButton';

const ButtonContainer = styled.div`
  & > * {
    margin-right: 5px;
  }
`;

const Container = styled.div`
  display: flex;
  min-height: 60px;
  padding-left: 10px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${colours.greyMedium};
`;

function Actions() {
  return (
    <Container>
      <ButtonContainer>
        <AddPopover>
          {({ togglePopover }) => (
            <Button bsStyle='important' bsSize='lg' onClick={togglePopover}>
              <i className='fas fa-plus' />
              New
            </Button>
          )}
        </AddPopover>
      </ButtonContainer>
      <ButtonContainer>
        <HeaderFilter iconBefore={faSearch} onClick={openGoto}>
          Search
        </HeaderFilter>
      </ButtonContainer>
    </Container>
  );
}

export default Actions;
